import { defineComponent } from 'vue';
import openModal from '@/components/modal';
import repository from './account-repository';
import { requiresClientAction } from '.';
import SocialAccountsModal from './AccountsModal.vue';
import { matches as willShowPopup } from './accounts-popup';

export default defineComponent({
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    if (willShowPopup(this.$route)) return;
    repository
      .findAll(this.clientId)
      .then((socialAccounts) => {
        const unhealthy = socialAccounts.filter(requiresClientAction);
        if (!socialAccounts.length || unhealthy.length > 0) {
          openModal(SocialAccountsModal, { parent: this, clientId: this.clientId });
        }
      });
  },
});
